import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import { ErisFormFieldType } from 'eris-forms';

// copied eris-form checkbox and added [checked]="field.formControl.value", remove it when the 
// bug is fixed in eris-form
@Component({
    selector: 'lib-checkbox',
    template: `
        <label>
            <input [checked]="field.formControl.value" #checkbox type="checkbox" (change)="field.formControl.setValue($event.target.checked)"><span>{{field.templateOptions.label}}</span>
        </label>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends ErisFormFieldType implements AfterViewInit{

    get type(): string {
        return this.to.type || 'checkbox';
    }

    ngAfterViewInit(): void {
        this.field.formControl.setValue(false);
    }

}
